import { APIClient } from "./api_helper";

import * as url from "./url_helper";

import { getAppConfig } from "config/configInitializer";

// Helper to get API client async
const getApiClient = async () => {
  const api = new APIClient();
  return api;
};

// Helper to get company_id async
const getCompanyId = async (): Promise<number> => {
  const config = getAppConfig();
  return config.company.COMPANY_ID;
};

// Gets the logged in user data from local session
export const getLoggedInUser = async () => {
  const user = localStorage.getItem("user");
  if (user) return JSON.parse(user);
  return null;
};

// is user is logged in
export const isUserAuthenticated = async () => {
  return getLoggedInUser() !== null;
};

// Sales Register
export const postSalesRegisterFormData = async (data: FormData) => {
  const api = await getApiClient();
  return await api.createFormData(url.SALES_REGISTER, data);
};

// Invest Register
export const postInvestRegisterFormData = async (data: FormData) => {
  const api = await getApiClient();
  return await api.create(url.INVEST_REGISTER, data);
};

// Login Method
export const postFakeLogin = async (params: any) => {
  const api = await getApiClient();
  const company_id = await getCompanyId();
  return await api.create(
    url.POST_LOGIN +
      `?username=${params.email}&password=${params.password}&companyId=${company_id}`,
    ""
  );
};

// GET AUTH DATA
export const getAuthList = async () => {
  const api = await getApiClient();
  return await api.get(url.GET_AUTH_DATA, "");
};

// POST FORGOT_PASSWORD
export const forgotPassword = async (data: any) => {
  const api = await getApiClient();
  const company_id = await getCompanyId();
  return await api.create(
    `${url.FORGOT_PASSWORD}?email=${data.email}&company_id=${company_id}`,
    ""
  );
};

// POST FORGOT_PASSWORD_NEW_PASS
export const forgotPasswordNewPass = async (data: any) => {
  const api = await getApiClient();
  return await api.create(
    `${url.FORGOT_PASSWORD_NEW_PASS}/${data.passwordChangeGuid}`,
    data
  );
};

export const postDecodeEncryptLogin = async (data: any) => {
  const api = await getApiClient();
  return await api.create(url.POST_DECODE_ENCRYPT_LOGIN, data);
};

// postForgetPwd
export const postFakeForgetPwd = async (data: any) => {
  const api = await getApiClient();
  return await api.create(url.POST_FAKE_PASSWORD_FORGET, data);
};

// Edit profile
export const postJwtProfile = async (data: any) => {
  const api = await getApiClient();
  return await api.create(url.POST_EDIT_JWT_PROFILE, data);
};

export const postFakeProfile = async (data: any) => {
  const api = await getApiClient();
  return await api.update(url.POST_EDIT_PROFILE + "/" + data.idx, data);
};

// Register Method
export const postJwtRegister = async (url: string, data: any) => {
  const api = await getApiClient();
  return await api.create(url, data).catch((err) => {
    var message;
    if (err.response && err.response.status) {
      switch (err.response.status) {
        case 404:
          message = "Sorry! the page you are looking for could not be found";
          break;
        case 500:
          message =
            "Sorry! something went wrong, please contact our support team";
          break;
        case 401:
          message = "Invalid credentials";
          break;
        default:
          message = err[1];
          break;
      }
    }
    throw message;
  });
};

// Login Method
export const postJwtLogin = async (data: any) => {
  const api = await getApiClient();
  return await api.create(url.POST_FAKE_JWT_LOGIN, data);
};

// postForgetPwd
export const postJwtForgetPwd = async (data: any) => {
  const api = await getApiClient();
  return await api.create(url.POST_FAKE_JWT_PASSWORD_FORGET, data);
};

// GET TRANSLATION
export const getTranslations = async (languageCode: any) => {
  const api = await getApiClient();
  return await api.create(url.GET_TRANSLATION + `${languageCode}`, "");
};

// CHECK EMAIL EXIST
export const checkEmailExist = async (email: string) => {
  const api = await getApiClient();
  return await api.get(url.GET_CHECK_EMAIL_EXIST + `?email=${email}`, "");
};

// get Task
export const getTaskList = async () => {
  const api = await getApiClient();
  return await api.get(url.GET_TASK_LIST, "");
};
export const addNewTask = async (task: any) => {
  const api = await getApiClient();
  return await api.create(url.ADD_NEW_TASK, task);
};
export const updateTask = async (task: any) => {
  const api = await getApiClient();
  return await api.update(url.UPDATE_TASK, task);
};
export const deleteTask = async (task: any) => {
  const api = await getApiClient();
  return await api.delete(url.DELETE_TASK, { headers: { task } });
};

// Kanban Board
export const getTasks = async () => {
  const api = await getApiClient();
  return await api.get(url.GET_TASKS, "");
};
export const addNewTasks = async (card: any) => {
  const api = await getApiClient();
  return await api.create(url.ADD_TASKS, card);
};
export const updateTasks = async (card: any) => {
  const api = await getApiClient();
  return await api.put(url.UPDATE_TASKS, card);
};
export const deleteTasks = async (card: any) => {
  const api = await getApiClient();
  return await api.delete(url.DELETE_TASKS, { headers: { card } });
};

// GET COUNTRY LIST
export const getCountryList = async () => {
  const api = await getApiClient();
  return await api.get(url.GET_COUNTRY_LIST, "");
};
export const getCountryListInt2 = async () => {
  const api = await getApiClient();
  return await api.get(url.GET_COUNTRY_LIST_INT2, "");
};

//! PARTNER
// GET DOCUMENT TYPE LIST
export const getDocumentTypeList = async () => {
  const api = await getApiClient();
  return await api.get(url.GET_DOCUMENT_TYPE_LIST, "");
};

// SUMMARY CARDS
export const getSummaryCards = async (id: number) => {
  const api = await getApiClient();
  return await api.get(
    url.PARTNER_QUERY + `${id}` + url.GET_SUMMARY_CARD_INFO,
    ""
  );
};

// REFERRAL LINK DETAIL
export const getReferralLinkDetails = async (id: number) => {
  const api = await getApiClient();
  return await api.get(
    url.PARTNER_QUERY + `${id}` + url.GET_REFERAL_LINK_INFO,
    ""
  );
};

// CONTRACTS TO PARTNER
export const getContractsToPartner = async (id: any) => {
  const api = await getApiClient();
  return await api.get(`${id}` + url.GET_CONTRACTS_TO_PARTNER, "");
};

// ADD REFERRAL LINK DETAILS
export const addReferralLinkDetailsForLanguage = async (
  id: number,
  data: any
) => {
  const api = await getApiClient();
  return await api.create(
    url.PARTNER_QUERY + `${id}` + url.ADD_REFERRAL_LINK_DETAILS,
    data
  );
};

// REBATE DETAIL
export const getRebateDetails = async (id: number) => {
  const api = await getApiClient();
  return await api.get(
    url.PARTNER_QUERY + `${id}` + url.GET_REBATE_DETAILS,
    ""
  );
};

// IB ONBOARDING PERSONAL INFO
export const addIBOnboardingPersonalInfo = async (data: any) => {
  const api = await getApiClient();
  return await api.create(url.IB_ONBOARDING_PERSONAL_INFO, data);
};

// INVEST IB ONBOARDING SMS VERIFICATION SMS REQUEST
export const addInvestIBOnboardingSMSReq = async (data: any) => {
  const api = await getApiClient();
  return await api.create(
    url.INVEST_IB_ONBOARDING_SMS_REQ + `?phoneNumber=${data.phone}`,
    ""
  );
};

// INVEST IB ONBOARDING SMS VERIFICATION CODE SEND
export const addInvestIBOnboardingCodeReq = async (id: number, data: any) => {
  const api = await getApiClient();
  return await api.create(
    url.PARTNER_QUERY.toLowerCase() +
      `${id}` +
      url.INVEST_IB_ONBOARDING_CODE_SEND,
    data
  );
};

// IB ONBOARDING BANK INFO
export const addIBOnboardingBankInfo = async (id: number, data: FormData) => {
  const api = await getApiClient();
  return await api.createFormData(
    url.PARTNER_QUERY + `${id}` + url.IB_ONBOARDING_BANK_INFO,
    data
  );
};

// UPDATE PERSONAL PASSWORD
export const changePersonalPassword = async (data: any) => {
  const api = await getApiClient();
  return await api.create(url.CHANGE_PERSONAL_PASSWORD, data);
};

// IB ONBOARDING IDENTITY VERIFICATION
export const addIBOnboardingIdentityVerify = async (
  id: number,
  data: FormData
) => {
  const api = await getApiClient();
  return await api.createFormData(
    url.PARTNER_QUERY + `${id}` + url.IB_ONBOARDING_IDENTITY_VERIFICATION,
    data
  );
};

// IB ONBOARDING ADDRESS VERIFICATION
export const addIBOnboardingAddressVerify = async (id: number, data: any) => {
  const api = await getApiClient();
  return await api.createFormData(
    url.PARTNER_QUERY + `${id}` + url.IB_ONBOARDING_ADDRESS_VERIFICATION,
    data
  );
};

//  PARTNER CLIENTS (DASHBOARD GRAPHİC)
export const getPartnerClients = async (id: number) => {
  const api = await getApiClient();
  return await api.get(
    url.PARTNER_QUERY.toLowerCase() +
      `${id}` +
      url.GET_PARTNER_CLIENTS_GRAPHIC_INFO,
    ""
  );
};

// DASHBOARD GRAPHİC PARTNER TRADING VOLUME
export const getPartnerTradingVolume = async (id: number) => {
  const api = await getApiClient();
  return await api.get(
    url.PARTNER_QUERY + `${id}` + url.GET_PARTNER_TRADING_VOLUME_GRAPHIC_INFO,
    ""
  );
};

// DASHBOARD GRAPHİC PARTNER TRADING VOLUME
export const getPartnerBalance = async (id: number) => {
  const api = await getApiClient();
  return await api.get(
    url.PARTNER_QUERY + `${id}` + url.GET_PARTNER_BALANCE_GRAPHIC_INFO,
    ""
  );
};

//  GET USER ADDRESS INFOS
export const getUserAddressInfos = async () => {
  const api = await getApiClient();
  return await api.get(url.GET_USER_ADDRESS_INFOS, "");
};

// PNL SHARE CONTRACT INFO
export const getPNLShareContractInfo = async (id: number) => {
  const api = await getApiClient();
  return await api.get(url.PNL_SHARE_CONTRACT_INFO + `${id}`, "");
};

// Reports Open Positions
export const getOpenPositions = async (id: number, data: any) => {
  const api = await getApiClient();
  return await api.create(
    url.PARTNER_QUERY.toLowerCase() + `${id}` + url.GET_REPORTS_OPEN_POSITIONS,
    data
  );
};

// Reports Client List
export const getClientList = async (id: number, data: any) => {
  const api = await getApiClient();
  return await api.create(
    url.PARTNER_QUERY.toLowerCase() + `${id}` + url.GET_PARTNER_CLIENTS,
    data
  );
};

// Reports Closed Trades
export const getClosedTrades = async (id: number, data: any) => {
  const api = await getApiClient();
  return await api.create(
    url.PARTNER_QUERY.toLowerCase() + `${id}` + url.GET_CLOSED_POSITIONS,
    data
  );
};

// Reports Deals
export const getDeals = async (id: number, data: any) => {
  const api = await getApiClient();
  return await api.create(url.PARTNER_QUERY + `${id}` + url.GET_DEALS, data);
};

// Reports Equity Report
export const getEquityReport = async (id: number, data: any) => {
  const api = await getApiClient();
  return await api.create(
    url.PARTNER_QUERY.toLowerCase() + `${id}` + url.GET_EQUITY_REPORTS,
    data
  );
};

// Reports Money Transfer Report
export const getMoneyTransferReport = async (id: number, data: any) => {
  const api = await getApiClient();
  return await api.create(
    url.PARTNER_QUERY.toLowerCase() + `${id}` + url.GET_MONEY_TRANSFERS,
    data
  );
};

// Reports Sub Ib List
export const getSubIbList = async (id: number, data: any) => {
  const api = await getApiClient();
  return await api.create(
    url.PARTNER_QUERY.toLowerCase() + `${id}` + url.GET_SUB_IBS,
    data
  );
};

// Reports Top Client Reports
export const getTopClientReport = async (id: number, data: any) => {
  const api = await getApiClient();
  return await api.create(
    url.PARTNER_QUERY.toLowerCase() + `${id}` + url.GET_TOP_CLIENTS,
    data
  );
};

// Reports Top Client Reports
export const getAllInstrumentGroups = async () => {
  const api = await getApiClient();
  return await api.get(url.GET_INSTRUMENT_GROUPS, "");
};

// CONTRACTS
export const getPagedContracts = async (id: number, data: any) => {
  const api = await getApiClient();
  return await api.create(
    url.PARTNER_QUERY.toLowerCase() + `${id}` + url.GET_PAGED_CONTRACTS,
    data
  );
};

// CREATE OWN CONTRACTS
export const addOwnContracts = async (id: number, data: any) => {
  const api = await getApiClient();
  return await api.create(url.ADD_OWN_CONTRACTS + `${id}`, data);
};

// OWN CONTRACT REVIEW
export const getOwnContractReview = async (id: number) => {
  const api = await getApiClient();
  return await api.get(url.GET_OWN_CONTRACT_REVIEW + `${id}`, "");
};

// CONTRACTS DETAIL
export const getContractDetail = async (data: any) => {
  const api = await getApiClient();
  return await api.create(url.GET_PAGED_CONTRACT_ACCOUNT, data);
};

// CONTRACTS STANDART RATES
export const getContractsStandartRates = async (id: number, data: any) => {
  const api = await getApiClient();
  return await api.get(url.GET_STANDART_RATES + `${id}`, data);
};

// OLD CONTRACT RATES
export const getOldContractsRates = async (id: number) => {
  const api = await getApiClient();
  return await api.get(url.GET_OLD_CONTRACT_RATES + `${id}`, "");
};

// GET SCA ACCOUNT INFO LIST>
export const getScaAccountInfoList = async () => {
  const api = await getApiClient();
  return await api.get(url.GET_SCA_ACCOUNT_INFO_LIST, "");
};

// GET WALLET ACCOUNT INFO LIST>
export const getWalletAccountInfoList = async (id: number) => {
  const api = await getApiClient();
  return await api.get(url.GET_WALLET_ACCOUNT_INFO_LIST + `${id}`, "");
};

// GET SCA DATE OF BIRTH INFO
export const getDateOfBirthInfo = async (id: number) => {
  const api = await getApiClient();
  return await api.get(
    url.PARTNER_QUERY + `${id}` + url.GET_USER_DATE_OF_BIRTH_INFO,
    ""
  );
};

// WITHDRAWAL POST INFO
export const addWithdrawalInfo = async (data: any) => {
  const api = await getApiClient();
  return await api.create(url.ADD_WITHDRAWAL_INFO, data);
};

// WITHDRAWAL WALLET INFO POST
export const addWithdrawalWalletInfo = async (data: any) => {
  const api = await getApiClient();
  return await api.create(url.ADD_WITHDRAWAL_WALLET_INFO, data);
};

// WITHDRAWAL POST INFO
export const addInternalTransferInfo = async (data: any) => {
  const api = await getApiClient();
  return await api.create(url.ADD_INTERNAL_TRANSFER_INFO, data);
};

// GET DEPOSIT REDIRECT PARAMETER
export const getDepositRedirectParameter = async () => {
  const api = await getApiClient();
  return await api.get(url.GET_DEPOSIT_REDIRECT_PARAMETER, "");
};

// Get REBATES
export const getRebates = async (id: number, data: any) => {
  const api = await getApiClient();
  return await api.create(
    url.PARTNER_QUERY.toLowerCase() + `${id}` + url.GET_REBATES,
    data
  );
};

export const getRebatesPNL = async (id: number, data: any) => {
  const api = await getApiClient();
  return await api.create(
    url.PARTNER_QUERY.toLowerCase() + `${id}` + url.GET_REBATES_PNL,
    data
  );
};

// PAYMENT HISTORY
export const getPagedPaymentHistoryReport = async (id: number, data: any) => {
  const api = await getApiClient();
  return await api.create(
    url.PARTNER_QUERY + `${id}` + url.GET_PAGED_PAYMENT_HISTORY_REPORT,
    data
  );
};

// GET OFFICES INFO
export const getOfficesInfo = async () => {
  const api = await getApiClient();
  return await api.get(url.GET_OFFICES_INFO, "");
};

// GET LOGIN INFO
export const getLoginInfo = async (partnerId: number, searchString: string) => {
  const api = await getApiClient();
  return await api.get(
    url.PARTNER_QUERY +
      `${partnerId}` +
      url.GET_LOGIN_INFO +
      `?searchString=${searchString}`,
    ""
  );
};

// GET SYMBOL INFO
export const getSymbolInfo = async (
  partnerId: number,
  searchString: string
) => {
  const api = await getApiClient();
  return await api.get(
    url.PARTNER_QUERY +
      `${partnerId}` +
      url.GET_SYMBOL_INFO +
      `?searchString=${searchString}`,
    ""
  );
};

// GET REQ DOCUMENTS
export const getRequestedDocuments = async (partnerId: number) => {
  const api = await getApiClient();
  return await api.get(
    url.PARTNER_QUERY + `${partnerId}` + url.GET_REQ_DOCUMENTS,
    ""
  );
};

// POST REQ DOCUMENTS
export const addRequestedDocuments = async (partnerId: number, data: any) => {
  const api = await getApiClient();
  return await api.createFormData(
    url.PARTNER_QUERY + `${partnerId}` + url.POST_REQ_DOCUMENTS,
    data
  );
};

//! SALES

// SALES REGISTER
export const postSalesRegister = async (data: any) => {
  const api = await getApiClient();
  return await api.create(url.SALES_REGISTER, data);
};

// SALES SUMMARY CARDS
export const getSalesSummaryCards = async (id: number, data: any) => {
  const api = await getApiClient();
  return await api.create(url.GET_SALES_SUMMARY_CARD_INFO + `${id}`, data);
};

// SALES GET REFERRAL LINK DETAILS INFO
export const getSalesReferralLinkDetails = async (id: number) => {
  const api = await getApiClient();
  return await api.get(url.GET_SALES_REFERRAL_LINK_DETAILS_INFO + `${id}`, "");
};

// DASHBOARD GRAPHİC PARTNER TRADING VOLUME
export const getSalesNetworkChart = async (id: number, data: any) => {
  const api = await getApiClient();
  return await api.create(url.GET_SALES_NETWORK_GRAPHIC_INFO + `${id}`, data);
};

// SALES ADD REFERRAL LINK DETAILS
export const addSalesReferralLinkDetailsForLanguage = async (
  id: number,
  data: any
) => {
  const api = await getApiClient();
  return await api.create(url.ADD_SALES_REFERRAL_LINK_DETAILS + `${id}`, data);
};

// GET SALES REBATE DETAILS
export const getSalesRebateDetails = async (id: number) => {
  const api = await getApiClient();
  return await api.get(
    url.SELLER_QUERY + `${id}` + url.GET_SALES_REBATE_DETAILS,
    ""
  );
};

// SALES GET REPORTS PARTNER LIST
export const getSalesPartnerList = async (id: number, data: any) => {
  const api = await getApiClient();
  return await api.create(url.GET_SALES_REPORTS_PARTNER_LIST + `${id}`, data);
};

// SALES GET REPORTS RETAIL LIST
export const getSalesClientList = async (id: number, data: any) => {
  const api = await getApiClient();
  return await api.create(url.GET_SALES_REPORTS_CLIENT_LIST + `${id}`, data);
};

// SALES GET REPORTS NETWORK LIST
export const getSalesNetworkList = async (id: number, data: any) => {
  const api = await getApiClient();
  return await api.create(url.GET_SALES_REPORTS_NETWORK_LIST + `${id}`, data);
};

// SALES GET REPORTS NETWORK LIST
export const getSalesMoneyTransferList = async (id: number, data: any) => {
  const api = await getApiClient();
  return await api.create(
    url.GET_SALES_REPORTS_MONEY_TRANSFER_LIST + `${id}`,
    data
  );
};

// SALES GET REPORTS EQUITY
export const getSalesEquityReport = async (id: number, data: any) => {
  const api = await getApiClient();
  return await api.create(url.GET_SALES_REPORTS_EQUITY + `${id}`, data);
};

// SALES GET CONTRACTS DETAIL
export const getSalesContractDetail = async (data: any) => {
  const api = await getApiClient();
  return await api.create(url.GET_SALES_PAGED_CONTRACT_ACCOUNT_DETAIL, data);
};

// SALES REBATE / COMMISSION
export const getSalesCommission = async (id: number, data: any) => {
  const api = await getApiClient();
  return await api.create(
    url.SELLER_QUERY + `${id}` + url.GET_SALES_PAGED_COMMISSINON_DETAIL,
    data
  );
};

// PAYMENT HISTORY
export const getSalesPaymentHistoryReport = async (id: number, data: any) => {
  const api = await getApiClient();
  return await api.create(
    url.GET_SALES_PAGED_PAYMENT_HISTORY_REPORT + `${id}`,
    data
  );
};
